export const FETCH_MARKET_ITEMS = 'FETCH_MARKET_ITEMS';
export const APPEND_MARKET_ITEMS = 'APPEND_MARKET_ITEMS';
export const FETCH_MARKET_DETAILS = 'FETCH_MARKET_DETAILS';
export const SET_MARKET_FILTERS = 'SET_MARKET_FILTERS';
export const RESET_MARKET_DATA = 'RESET_MARKET_DATA';
export const FETCH_MARKET_OFFER = 'FETCH_MARKET_OFFER';
export const BUY_MARKET_OFFER = 'BUY_MARKET_OFFER';
export const SEND_SCAN_TRIGGER_REQUEST = 'SEND_SCAN_TRIGGER_REQUEST';
